import { render } from "./ErrorCmpMessage.vue?vue&type=template&id=710e721c&ts=true"
import script from "./ErrorCmpMessage.vue?vue&type=script&lang=ts"
export * from "./ErrorCmpMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__